export const TIERS = ['doctrine', 'project', 'decision', 'entity', 'concept', 'topic', 'source'] as const;
export type Tier = (typeof TIERS)[number];

export type RelevanceSource = 'vector' | 'keyword' | 'both';

export interface SearchResult {
  slug: string;
  title: string;
  page_type: string;
  tier: Tier | string;
  score: number;
  sources: RelevanceSource[] | string[];
  body_md: string;
  traversed_from?: string;
  source_path?: string;
}

export interface SearchTiming {
  total_ms: number;
}

export interface SearchResponse {
  results: SearchResult[];
  timing?: SearchTiming;
}

export interface SearchRequest {
  query: string;
  top_k?: number;
  tier?: string;
}
